function e(t, a) {
  return t > a;
}
var r = e;
export {
  r as _
};
//# sourceMappingURL=_baseGt.js.map
